import { Icon } from '@material-ui/core';
import React, { useContext, useState } from 'react';
import { Accordion } from 'react-bootstrap';
import { Link, useLocation } from 'react-router-dom';
import { ExtraDataContext } from '../Context/ExtraDataContext';

const SideNavExpand = ({ item, children }) => {
    const [accExpand, setAccExpand] = useState(false);

    const { pathname } = useLocation();

    const { name, icon } = item;
    const { isDarkTheme } = useContext(ExtraDataContext);

    return (
        <Accordion className="mx-3 px-2" id="sideNavExpandAcc">
            <Accordion.Item eventKey="10" className={`${isDarkTheme ? 'DEFAULT_DARK_THEME_COLORS' : 'DEFAULT_LIGHT_THEME_COLORS'}`}>
                <Accordion.Header className="" onClick={() => setAccExpand(!accExpand)}>
                    <div className="d-flex justify-content-between align-items-center sideNavLabel w-100">
                        <div className="d-flex align-items-center">
                            {icon && (
                                <Icon>{icon}</Icon>
                            )}
                            <span className="mx-1">
                                {name}
                            </span>
                        </div>
                        <Icon>{accExpand ? "keyboard_arrow_down" : "chevron_right"}</Icon>
                    </div>
                </Accordion.Header>
                <Accordion.Body className="p-0">
                    <div className="d-block w-100 ">
                        {children &&
                            children.map((childItem, index) => (
                                <div key={index}>
                                    <Link to={`${childItem.path}`}
                                        className={`${pathname === childItem.path ? 'activeSideNav' : ''} d-flex align-items-center text-decoration-none py-2 ${isDarkTheme ? 'DEFAULT_DARK_LINK' : 'DEFAULT_LIGHT_LINK'}`}>
                                        <Icon>arrow_right</Icon> {childItem.name}
                                    </Link>
                                </div>
                            ))
                        }
                    </div>
                </Accordion.Body>
            </Accordion.Item>
        </Accordion>
    );
};

export default SideNavExpand;